module.exports = __webpack_public_path__ + "static/media/play-fantastic.5347a534.png";